import { render, staticRenderFns } from "./listadoPagosMercadoPago.vue?vue&type=template&id=2a8f90f0&scoped=true&"
import script from "./listadoPagosMercadoPago.vue?vue&type=script&lang=js&"
export * from "./listadoPagosMercadoPago.vue?vue&type=script&lang=js&"
import style0 from "./listadoPagosMercadoPago.vue?vue&type=style&index=0&id=2a8f90f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8f90f0",
  null
  
)

export default component.exports